import { createSlice } from "@reduxjs/toolkit";

const DEFAULT_ACTIVE_CASE = {
  caseID: 0,
  caseName: "",
  caseNote: "",
  temperatureTypeId: null,
  temperatureValue: null,
};

const initialState = {
  projectID: 0,
  projectActiveTab: null,
  caseName: "Case 1",
  projectName: null,
  treatmentName: null,
  treatmentObjID: null,
  isTechnologyAccess: true,
  isProductAccess: true,
  isMldDesign: false,
  Tchnology: [],
  case: [],
  activeCase: { ...DEFAULT_ACTIVE_CASE },
  projectConfig: {
    unitConfig: {
      defaultValues: [],
      selectedUnits: [],
      selectedUnitType: 0,
    },
    currencyConfig: {
      defaultValues: [],
      selectedCurrency: {
        currencyUnit: "$",
        currencyID: 1,
        currencyName: "US Dollar($)",
        isDefault: true,
        currencyValue: "1",
      },
    },
    pumpCofig: {
      pumpList: [],
    },
    caseConfig: {
      caseList: [],
      caseNameList: [],
    },
  },
  data: {
    projectID: 0,
    caseId: 0,
    projectName: "",
    Tchnology: "",
  },
  projectData: {},
  projectChemicalCosts: {},
  isUserInsideProjectFlag: false,
};

export const ProjectInfoSlice = createSlice({
  name: "ProjectInfo",
  initialState,
  reducers: {
    updateProjectInfo: (state, action) => {
      state.data = action.payload;
    },
    updateProjectAccess: (state, action) => {
      const { isProductAccess, isTechnologyAccess } = action.payload;
      if (isProductAccess !== undefined) state.isProductAccess = isProductAccess;
      if (isTechnologyAccess !== undefined) state.isTechnologyAccess = isTechnologyAccess;
    },
    updateActiveCase: (state, action) => {
      state.activeCase = action.payload;
    },
    updateUnitConfig: (state, action) => {
      const incomingUnit = action.payload;
      const selectedUnitType = incomingUnit[0].uomSelectType;
      const isUnitNew = incomingUnit[0].unitKey.filter(item => item.isSelected);
      const selectedUnits = [];
      if (isUnitNew.length > 0) {
        incomingUnit.map(item => {
          const unitTag = item.unitKey.filter(item => item.isSelected);
          if (unitTag.length > 0) {
            selectedUnits[item.uomTypeID] = unitTag[0].uomName;
          } else {
            selectedUnits[item.uomTypeID] = item.unitKey[0].uomName;
          }
        });
      }

      state.projectConfig.unitConfig.selectedUnits = selectedUnits;
      state.projectConfig.unitConfig.defaultValues = incomingUnit;
      state.projectConfig.unitConfig.selectedUnitType = selectedUnitType;
    },
    updatePumpList: (state, action) => {
      state.projectConfig.pumpCofig.pumpList = action.payload;
    },
    updateCaseConfig: (state, action) => {
      state.projectConfig.caseConfig.caseList = action.payload;
      state.projectConfig.caseConfig.caseNameList = action.payload.map(item => item.caseName);
    },
    updateProjectCurrency: (state, action) => {
      const selectedCurrency = action.payload.find(item => item.isDefault);
      if (!selectedCurrency) return;
      const currencyName = selectedCurrency.currencyName.replace("(", " ").replace(")", "").split(" ");
      const symbole = currencyName[currencyName.length - 1];
      state.projectConfig.currencyConfig.selectedCurrency = {
        ...action.payload.find(item => item.isDefault),
        currencyUnit: symbole,
      };
    },
    updateProjectInfoState: (state, { payload: { type, data } }) => {
      state[type] = data;
    },
    resetProjectInfo: (state, { payload }) => {
      state = { ...initialState };
      const currentCase = payload?.activeCase;
      if (currentCase !== undefined) {
        state.activeCase = currentCase;
      } else {
        state.activeCase = { ...DEFAULT_ACTIVE_CASE };
      }
      return state;
    },
    resetActiveCase: state => {
      state.activeCase = { ...DEFAULT_ACTIVE_CASE };
    },
    updateInsideProjectFlag: (state, action) => {
      state.isUserInsideProjectFlag = action.payload;
    },
    updateProjectActiveTab: (state, action) => {
      state.projectActiveTab = action.payload;
    },
    updateMldDesignFlag: (state, action) => {
      state.isMldDesign = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updatePumpList,
  resetProjectInfo,
  updateUnitConfig,
  updateCaseConfig,
  updateActiveCase,
  updateProjectInfo,
  updateProjectCurrency,
  updateProjectInfoState,
  resetActiveCase,
  updateInsideProjectFlag,
  updateProjectAccess,
  updateProjectActiveTab,
  updateMldDesignFlag,
} = ProjectInfoSlice.actions;

export default ProjectInfoSlice.reducer;
